<script>
  export let data;
  let convert = (k) => {
    let output = "";
    let hrs = k / 60;
    if (hrs <= 0) {
      hrs = Math.ceil(hrs);
    } else {
      hrs = Math.floor(hrs);
    }
    if (hrs != 0) {
      output = hrs + " " + " H";
    }
    let minutes = Math.abs(k) - Math.abs(hrs) * 60;
    if (minutes != 0) {
      if (hrs != 0) {
        output = output + " " + minutes + " M";
      } else {
        output = output + minutes + " " + " M";
      }
    }
    if (minutes == 0 && hrs == 0) {
      output = "0 " + " M";
    }
    return output;
  };
</script>

<div class="leftContent">
  <div class="hoursContainer">
    <h1>{convert(data.availableHrs)}</h1>
    <i class="bx bx-time-five" />
  </div>
</div>

<style>
  * {
    padding: 0;
    margin: 0;
  }

  .bloc1 {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    flex-direction: row;
  }

  .hoursContainer {
    display: flex;
  }

  .hoursContainer h1 {
    margin-right: 1.5rem;
  }

  .leftContent h1 {
    color: rgba(14, 143, 108, 1);
  }

  .col3 {
    width: 40%;
  }

  .leftContent i {
    color: rgba(14, 143, 108, 1);
    font-size: 3em;
  }

  .leftContent {
    height: 9rem;
    border: 1px solid #0e8f6c;
    padding: 1rem;
    border-radius: 8px;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    flex-direction: row;
  }

  @media only screen and (max-width: 1100px) {
    .leftContent {
      height: auto;
    }
  }
</style>
